"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _excluded = ["actionBarClasses", "ContentProps", "classes", "children", "closeIcon", "contentHeaderSection", "dataMetrics", "DialogHeaderProps", "disableEscapeKeyDown", "drawerWidth", "ModalProps", "onClose", "open", "primaryButton", "secondaryButton", "subtitle", "subtitleToolTip", "title", "titleToolTip", "variant"],
  _excluded2 = ["className"],
  _excluded3 = ["className"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    actionBar: {
      alignItems: 'center',
      display: 'flex',
      height: 52,
      justifyContent: 'flex-end',
      marginTop: 'auto',
      padding: theme.spacing(0, 3)
    },
    closePaneIcon: {
      cursor: 'pointer',
      height: theme.spacing(3),
      width: theme.spacing(3)
    },
    closePaneWrapper: {
      gridArea: 'close',
      height: theme.spacing(3),
      width: theme.spacing(3)
    },
    dialogHeader: {
      boxSizing: 'border-box',
      display: 'grid',
      gridColumnGap: theme.spacing(2),
      gridTemplateAreas: function gridTemplateAreas(_ref) {
        var subtitle = _ref.subtitle;
        return subtitle ? '"title close" "subtitle ."' : '"title close"';
      },
      gridTemplateColumns: '1fr auto',
      gridTemplateRows: '1fr',
      height: function height(_ref2) {
        var subtitle = _ref2.subtitle;
        return subtitle ? 80 : 60;
      },
      padding: theme.spacing(2, 3)
    },
    drawerPaper: {
      boxShadow: theme.shadows[9],
      height: function height(_ref3) {
        var variant = _ref3.variant;
        return variant === 'floating' ? "calc(100% - ".concat(theme.spacing(4), "px - ").concat(theme.mixins.toolbar.minHeight, "px )") : null;
      },
      margin: function margin(_ref4) {
        var variant = _ref4.variant;
        return variant === 'floating' ? "".concat(theme.spacing(2) + theme.mixins.toolbar.minHeight, "px\n    ").concat(theme.spacing(2), "px\n    ").concat(theme.spacing(2), "px\n    ").concat(theme.spacing(2), "px") : null;
      },
      paddingTop: function paddingTop(_ref5) {
        var variant = _ref5.variant;
        return variant === 'standard' ? theme.mixins.toolbar.minHeight : null;
      },
      width: function width(_ref6) {
        var drawerWidth = _ref6.drawerWidth;
        return drawerWidth || theme.spacing(56);
      },
      // 448px
      zIndex: function zIndex(_ref7) {
        var variant = _ref7.variant;
        return variant === 'standard' ? theme.zIndex.appBar - 1 : null;
      }
    },
    primaryButton: {
      marginLeft: theme.spacing(2)
    },
    sidePanelContent: {
      flex: '1 1 0',
      overflowY: 'auto',
      padding: theme.spacing(2, 3)
    },
    subtitle: {
      gridArea: 'subtitle'
    },
    title: {
      gridArea: 'title'
    },
    truncatedText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  };
});
var defaultProps = {
  anchor: 'right',
  closeIcon: true,
  ContentProps: {},
  dataMetrics: {
    root: 'fuse_side_panel'
  },
  DialogHeaderProps: {},
  disableEscapeKeyDown: true,
  subtitleToolTip: true,
  titleToolTip: true,
  variant: 'standard'
};
var VARIANT_MAPPING = {
  floating: 'persistent',
  modal: 'temporary',
  standard: 'persistent'
};

/**
 * A side panel provides detailed information when you click a row in a table and actions associated with that specific element.
 */
var _ref9 = /*#__PURE__*/_react["default"].createElement(_Close["default"], null);
var SidePanel = /*#__PURE__*/_react["default"].forwardRef(function (_ref8, ref) {
  var actionBarClasses = _ref8.actionBarClasses,
    ContentProps = _ref8.ContentProps,
    classes = _ref8.classes,
    children = _ref8.children,
    closeIcon = _ref8.closeIcon,
    contentHeaderSection = _ref8.contentHeaderSection,
    dataMetrics = _ref8.dataMetrics,
    DialogHeaderProps = _ref8.DialogHeaderProps,
    disableEscapeKeyDown = _ref8.disableEscapeKeyDown,
    drawerWidth = _ref8.drawerWidth,
    ModalProps = _ref8.ModalProps,
    _onClose = _ref8.onClose,
    open = _ref8.open,
    primaryButton = _ref8.primaryButton,
    secondaryButton = _ref8.secondaryButton,
    subtitle = _ref8.subtitle,
    subtitleToolTip = _ref8.subtitleToolTip,
    title = _ref8.title,
    titleToolTip = _ref8.titleToolTip,
    variant = _ref8.variant,
    props = (0, _objectWithoutProperties2["default"])(_ref8, _excluded);
  var componentClasses = useStyles({
    closeIcon: closeIcon,
    drawerWidth: drawerWidth,
    subtitle: subtitle,
    variant: variant
  });
  var InnerModalProps = _objectSpread({}, variant === 'modal' && {
    onClose: function onClose(event, reason) {
      return reason !== 'backdropClick' && _onClose && _onClose(event, reason);
    }
  }, {}, disableEscapeKeyDown && {
    disableEscapeKeyDown: disableEscapeKeyDown
  });
  var drawerProps = {
    ModalProps: _objectSpread({}, ModalProps, {}, InnerModalProps)
  };
  var contentPropsClassName = ContentProps.className,
    contentProps = (0, _objectWithoutProperties2["default"])(ContentProps, _excluded2);
  var dialogHeaderPropsClassName = DialogHeaderProps.className,
    dialogHeaderProps = (0, _objectWithoutProperties2["default"])(DialogHeaderProps, _excluded3);
  var actionBar = Boolean(primaryButton) || Boolean(secondaryButton);
  var titleWithToolTip = function titleWithToolTip(type, titleComponent) {
    return titleComponent ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      title: type
    }, titleComponent) : undefined;
  };
  var memoizedTitle = (0, _react.useMemo)(function () {
    if (typeof title === 'string') {
      return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: (0, _classnames["default"])(componentClasses.truncatedText, componentClasses.title),
        variant: "h6"
      }, title);
    }
    return title;
  }, [componentClasses.title, componentClasses.truncatedText, title]);
  var memoizedSubtitle = (0, _react.useMemo)(function () {
    if (typeof subtitle === 'string') {
      return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: componentClasses.truncatedText,
        color: "secondary",
        variant: "subtitle1"
      }, subtitle);
    }
    return subtitle;
  }, [subtitle, componentClasses.truncatedText]);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var titleSection = titleToolTip ? titleWithToolTip(title, memoizedTitle) : memoizedTitle;
  var subtitleSection = subtitleToolTip ? titleWithToolTip(subtitle, memoizedSubtitle) : memoizedSubtitle;
  return /*#__PURE__*/_react["default"].createElement(_Drawer["default"], (0, _extends2["default"])({
    classes: _objectSpread({}, classes, {
      // keep drawerPaper class here for backwards compatibility, the only way you could style the paper on the drawer was to override drawerPaper class
      // some teams have used it and we don't want to break it
      // eslint-disable-next-line react/prop-types
      paper: (0, _classnames["default"])(componentClasses.drawerPaper, classes && classes.paper, classes && classes.drawerPaper)
    }),
    "data-metrics": mergedDataMetrics.root,
    open: open,
    onClose: _onClose,
    ref: ref,
    variant: VARIANT_MAPPING[variant]
  }, drawerProps, props), /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(componentClasses.dialogHeader, dialogHeaderPropsClassName)
  }, dialogHeaderProps), titleSection, subtitle && subtitleSection, /*#__PURE__*/_react["default"].createElement("div", {
    className: componentClasses.closePaneWrapper
  }, closeIcon && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "Close",
    className: componentClasses.closePaneIcon,
    color: "secondary",
    onClick: _onClose
  }, _ref9))), contentHeaderSection, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(componentClasses.sidePanelContent, contentPropsClassName)
  }, contentProps), children), actionBar && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(componentClasses.actionBar, actionBarClasses)
  }, secondaryButton, primaryButton && /*#__PURE__*/_react["default"].createElement("span", {
    className: componentClasses.primaryButton
  }, primaryButton)));
});
SidePanel.defaultProps = defaultProps;
SidePanel.displayName = 'SidePanel';
SidePanel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override the action bar classes in the side panel
   * The action bar is a container that wraps the primary and secondary buttons
   * There is a <span> tag wrapped around the primary button. To override the styles, use a sibling selector. ie .my-class > span
   */
  actionBarClasses: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes["default"].oneOf(['left', 'top', 'right', 'bottom']),
  /**
   * The contents of the drawer.
   */
  children: _propTypes["default"].node,
  /**
   * @ignore
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].node,
  /**
   * If `true`, the CloseIcon is shown to close the Side Panel.
   */
  closeIcon: _propTypes["default"].bool,
  /**
   * Section to place a header before the content such as Tabs or Divider.
   */
  contentHeaderSection: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object]),
  /**
   * Pass down props to the main Side Panel Content which wraps the children.
   */
  ContentProps: _propTypes["default"].object,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Width to override default
   * Pass down props to the main Side Panel Dialog Header which wraps the title, subtitle and close button.
   */
  DialogHeaderProps: _propTypes["default"].object,
  /**
   * If 'false', when `Escape` key is pushed, the modal will close
   */
  disableEscapeKeyDown: _propTypes["default"].bool,
  /**
   * Width to override default.
   */
  drawerWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * @ignore
   */
  ModalProps: _propTypes["default"].object,
  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: _propTypes["default"].func,
  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes["default"].bool,
  /**
   * Pass in a component to place it as a Primary Button.
   * Primary Button is placed at the bottom.
   */
  primaryButton: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object]),
  /**
   * Pass in a component to place it as a Secondary Button.
   * Secondary Button is placed at the bottom to the left of the Primary Button.
   * If Secondary Button is only used, it takes the spot of the Primary Button.
   */
  secondaryButton: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object]),
  /**
   * Secondary text to provide/support more information about the Side Panel.
   */
  subtitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * Optional tool tip for the subtitle.
   */
  subtitleToolTip: _propTypes["default"].bool,
  /**
   * Main text to provide a short description of the Side Panel.
   */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  /**
   * Optional tool tip for the title.
   */
  titleToolTip: _propTypes["default"].bool,
  /**
   * Standard - Goes under the AppBar and has no backdrop
   * Modal - Goes over the AppBar and has a backdrop
   * Floating - Co-exists with the main content and pushes the content left when it opens
   */
  variant: _propTypes["default"].oneOf(['standard', 'modal', 'floating'])
} : {};
var _default = SidePanel;
exports["default"] = _default;